import React from 'react'

import GenericLazyLoadImage from 'components/generic/GenericLazyLoadImage'
import {
  SmallNavContainer,
  SmallLogoContainer,
  HamburgerMenuContainer,
  HamburgerMenuTopBar,
  HamburgerMenuMiddleBar,
  HamburgerMenuBottomBar,
  BaseHamburgerMenuItem,
  HamburgerMenuItem,
  SmallAnchor,
  StyledNavPanel,
  SmallNavItemsTopContainer,
  SmallNavItemsBottomContainer,
} from 'components/Header/Styled'

const NavItemsBottom = ({ buttonData: { link, text } }) => (
  <SmallNavItemsBottomContainer>
    <BaseHamburgerMenuItem key='Login' href='/log-in'>
      Login
    </BaseHamburgerMenuItem>
    <HamburgerMenuItem href={link} key={text}>
      {text}
    </HamburgerMenuItem>
  </SmallNavItemsBottomContainer>
)

function renderNavLinks(navigationItems) {
  return (
    navigationItems &&
    navigationItems.length > 0 &&
    navigationItems.map((item, id) => (
      <BaseHamburgerMenuItem href={item.link} key={id}>
        {' '}
        {item.title}
      </BaseHamburgerMenuItem>
    ))
  )
}

const StyledNavDropdownPanel = ({ show, navigationItems, buttonData }) => (
  <StyledNavPanel show={show}>
    <SmallNavItemsTopContainer>{renderNavLinks(navigationItems)}</SmallNavItemsTopContainer>
    <NavItemsBottom buttonData={buttonData} />
  </StyledNavPanel>
)

export const LoggedOutSmallHeader = ({
  altTag,
  logo,
  show,
  handleNavClick,
  siteNavigationItems,
  startedCta,
}) => (
  <>
    <SmallNavContainer>
      <SmallLogoContainer>
        <SmallAnchor href='/'>
          <GenericLazyLoadImage alt={altTag} src={logo} height='32px' width='32px' mt='8px' />
        </SmallAnchor>
        <HamburgerMenuContainer onClick={handleNavClick}>
          <HamburgerMenuTopBar changed={show} />
          <HamburgerMenuMiddleBar changed={show} />
          <HamburgerMenuBottomBar changed={show} />
        </HamburgerMenuContainer>
      </SmallLogoContainer>
    </SmallNavContainer>
    <StyledNavDropdownPanel
      show={show}
      navigationItems={siteNavigationItems}
      buttonData={startedCta}
    />
  </>
)
